import React, { Component } from 'react'

export default class FieldBox extends Component {
    state = {  }
    render() { 
        const { children } = this.props
        return ( 
            <div className="my-4">
                    { children }
            </div>
         );
    }
}
